import React, { Component } from 'react';
import classNames from 'classnames';
import { gettext } from '@eb/i18n-ebspa';

import { Button } from '@eb/eds-button';

import { getTabId, getPanelId } from '../util';

export default class TabItem extends Component {
    state = {
        isSelected: false,
    };

    // eslint-disable-next-line camelcase
    UNSAFE_componentWillReceiveProps(props) {
        /**
         * Okay, this seems overkill but fixes an issue on the first load
         * of the component. If the selected prop changed quickly in the
         * state of the parent, it was not completely reflected here.
         * Adding it to the state keeps this component in particular updated
         * all time.
         */
        this.setState({
            isSelected: props.isSelected,
        });
    }

    render() {
        const { value, displayName, onSelected } = this.props;
        const { isSelected } = this.state;

        const tabItemClasses = classNames(
            'eds-tabs__item',
            'eds-l-pad-hor-2',
            'eds-l-md-pad-hor-3',
            'eds-l-mw-pad-hor-4',
            'eds-l-ln-pad-hor-4',
            'eds-l-lg-pad-hor-4',
            'eds-l-lw-pad-hor-4',
            {
                'eds-tabs__item--selected': isSelected,

                // When displayName is not set we want to hide it
                // or else there will be a gap
                'eds-hide': !displayName,
            },
        );

        const tabItemLinkClasses = classNames(
            'eds-tabs__item-link',
            'eds-l-pad-vert-3',
        );

        let controlledPanel;

        let selectedMessage = '';

        if (isSelected) {
            controlledPanel = getPanelId(value);
            selectedMessage = ' Selected category.';
        }

        return (
            <li
                id={getTabId(value)}
                className={tabItemClasses}
                aria-controls={controlledPanel}
            >
                <Button
                    style="none"
                    __containerClassName={tabItemLinkClasses}
                    onClick={onSelected}
                    data-spec={`tab-link--${value}`}
                    data-automation={`tab-link--${value}`}
                    aria-label={gettext(
                        `Filter by ${displayName} events.${selectedMessage}`,
                    )}
                >
                    <span className="eds-text-weight--heavy">
                        {displayName}
                    </span>
                </Button>
            </li>
        );
    }
}
